import ExtensionRounded from '@mui/icons-material/ExtensionRounded';
import { assessmentsModule } from './assessments';
import { enemModule } from './enem';
import type { FrontModule, IconComponent } from './types';

/**
 * Every module the front-end knows. Whether each one shows up is decided at
 * runtime by the back-end (`/me` → modules switched on in the admin panel).
 */
export const MODULES: FrontModule[] = [assessmentsModule, enemModule];

export function findModule(key: string): FrontModule | undefined {
  return MODULES.find((m) => m.key === key);
}

/** Icon for a module, even one installed on the back-end but unknown to this front-end. */
export function moduleIcon(key: string): IconComponent {
  return findModule(key)?.icon ?? ExtensionRounded;
}
